export default {
  homeBannerImgLeft: 'image-left',
  homeBannerTxtWrapperRite: 'textwrapperRight',
  homeBannerTxtRite: 'text-Right',
  contentCollectionBuyNow: 'collection-buynow',
  'content-page-text-left': {
    mainWrapper: 'mainWrapper relative content-page-text-left',
    innerWrapper:
      'lg:max-w-container mx-auto flex items-center md:flex-row sm:flex-col sm:px-0 sm:text-center lg:py-0 lg:px-15 lg:h-500 sm:py-50',
    imageWrapper: 'imageWrapperSty sm:w-full md:w-6/12',
    imageStyles: 'imageStylesleft  sm:max-h-300 lg:max-h-440',
    textContent: 'textContent sm:w-full md:w-6/12 lg:text-left lg:pl-60',
    headingStyle:
      'headingStyle text-24 lg:text-36 leading-24 lg:leading-45 font-BebasNeueRegular mb-10 lg:mb-8',
    subText:
      'subsubText headingStyle text-16 lg:text-24 text-grey leading-28 font-BebasNeueRegular mb-40 collection-subText',
    ratingTextCount: 'ratingTextCount ml-15',
    ratingWrapper: 'ratingWrapper mb-20',
    'content-page-left-primary-image': 'contentimag',
    knowMoreButton:
      'knowMoreButton text-black no-underline font-BebasNeueRegular px-15 py-7 lg:py-10 inline-block border-solid border-2 min-w-100 text-center',
  },
  'Goldie-content-page-text-left': {
    mainWrapper: 'mainWrapper relative content-page-text-left',
    innerWrapper:
      'lg:max-w-container mx-auto flex items-center md:flex-row sm:flex-row sm:px-0 sm:text-center lg:py-0 lg:px-15 lg:h-500 GoldieinnerWrapperleft',
    imageWrapper: 'imageWrapperSty sm:w-full md:w-6/ lg:w-full GoldieimageWrapperleft',
    imageStyles: 'imageStylesleft  sm:max-h-300 lg:max-h-440',
    textContent: 'textContent sm:w-full md:full lg:text-left lg:pl-60',
    headingStyle:
      'headingStyle lg:text-36 leading-24 lg:leading-45  mb-10 lg:mb-8 Goldietextleft',
  },
  'home-page-text-left': {
    mainWrapper: 'mainWrapper relative content-page-text-left',
    innerWrapper:
      'sm:flex sm:overflow-hidden md:overflow-auto sm:flex-col-reverse md:flex-row sm:text-center md:text-left md:flex items-start flex-equal picture-inline-flex home-section w-full md:w-full lg:w-full home-section sticky-card banner-text',
    imageWrapper: 'imageWrapperSty sm:w-full md:w-full py-15p lg:py-0 sm:py-10p',
    imageStyles: 'imageStylesleft  max-h-280 md:max-h-76p mx-1.5p',
    textContent: 'textContent sm:w-full md:w-6/12 lg:text-left lg:pl-60',
    headingStyle:
      'headingStyle text-24 lg:text-36 leading-24 lg:leading-45 font-BebasNeueRegular mb-10 lg:mb-8',
    subText:
      'subsubText headingStyle text-16 lg:text-24 text-grey leading-28 font-BebasNeueRegular mb-40',
    ratingTextCount: 'ratingTextCount ml-15',
    ratingWrapper: 'ratingWrapper mb-20',
    'content-page-left-primary-image': 'contentimag',
    knowMoreButton:
      'knowMoreButton text-black no-underline font-BebasNeueRegular px-15 py-7 lg:py-10 inline-block border-solid border-2 min-w-100 text-center',
    textContentRight: 'xyz',
  },
  'content-page-text-right': {
    mainWrapper: 'mainWrapper relative content-page-text-right',
    innerWrapper:
    'lg:max-w-container mx-auto flex items-center md:flex-row-reverse sm:flex-col px-0 sm:text-center sm:py-50 lg:py-0 lg:h-500',
    imageWrapper: 'imageWrapperSty sm:w-full md:w-6/12',
    imageStyles: 'imageStylesright sm:max-h-300 lg:max-h-440',
    textContent: 'textContent sm:w-full md:w-6/12 lg:text-right lg:pr-60',
    headingStyle:
      'headingStyle text-24 lg:text-36 leading-24 lg:leading-45 font-BebasNeueRegular mb-10 lg:mb-8',
    subText:
      'subText headingStyle text-16 lg:text-24 text-grey leading-28 font-BebasNeueRegular mb-40 collection-subText',
    ratingTextCount: 'ratingTextCount ml-15',
    ratingWrapper: 'ratingWrapper mb-20',
    knowMoreButton:
      'knowMoreButton text-black no-underline font-BebasNeueRegular px-15 py-7 lg:py-10 inline-block border-solid border-2 min-w-100 text-center',
  },
  'Goldie-content-page-text-right': {
    mainWrapper: 'mainWrapper relative content-page-text-right',
    innerWrapper:
      'lg:max-w-container mx-auto flex items-center md:flex-row-reverse sm:flex-row-reverse px-0 sm:text-center lg:py-0 lg:h-500 GoldieinnerWrapperright',
    imageWrapper: 'imageWrapperSty sm:w-6/12 sm:p-0 md:w-6/12 GoldieimageWrapperright',
    imageStyles: 'imageStylesright sm:max-h-300 lg:max-h-440',
    textContent: 'textContent  md-w-full  lg:text-right lg:pr-60 Goldiecontentpagetextright',
    headingStyle:
      'headingStyle text-24 lg:text-36 leading-24 lg:leading-45  mb-10 lg:mb-8 text-left Goldietextright',
  },

  'go-grey-text-right': {
    mainWrapper: 'mainWrapper relative',
    innerWrapper:
      'lg:max-w-container mx-auto flex items-center md:flex-row sm:flex-col sm:px-0 sm:text-center lg:py-50 mt-40 lg:mt-0 lg:px-15',
    imageWrapper: 'imageWrapperSty sm:w-full md:w-6/12',
    textContent: 'textContent sm:w-full md:w-6/12 lg:text-right lg:pr-60',
    headingStyle:
      'go-grey-text-heading headingStyle text-36 leading-24 font-BebasNeueRegular mb-20 sm:absolute md:static top-0 left-0 right-0 max-w-300 lg:max-w-420 mx-auto md:w-full',
    subText:
      'subText headingStyle text-24 text-black leading-28 font-BebasNeueRegular mb-40',
    ratingTextCount: 'ratingTextCount ml-15',
    ratingWrapper: 'ratingWrapper mb-20',
    knowMoreButton:
      'knowMoreButton text-black no-underline font-BebasNeueRegular px-15 py-10 inline-block border-solid border-2 min-w-140 text-center',
  },
};
